import { render, staticRenderFns } from "./InvoicingView.vue?vue&type=template&id=0638213b&scoped=true&"
import script from "./InvoicingView.vue?vue&type=script&lang=js&"
export * from "./InvoicingView.vue?vue&type=script&lang=js&"
import style0 from "./InvoicingView.vue?vue&type=style&index=0&id=0638213b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0638213b",
  null
  
)

export default component.exports